import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import template from '@bingads-webui-component-legacy/language-selector/template/index.pug';
import ViewModel from '@bingads-webui-component-legacy/language-selector/viewmodel/index';
import eventDispatcher from '@bingads-webui-component-legacy/event-dispatcher/index';
import * as defaultLanguage from '@bingads-webui-component-legacy/language-selector/util/defaultLanguage';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!component/language-selector');

const defaultOptions = {
  i18nStrings: {
    Description: i18n.get('Campaign_Language_Description'),
    SaveWarning: i18n.get('Campaign_FinalValue_SaveWarning'),
    ChooseLanguage: i18n.get('Campaign_Language_Choose_Language'),
  },
  language: defaultLanguage.get(),
  languages: [],
  withInheritOption: false,
  enableArabic: false,
  enableSimplifiedChinese: false,
};

export default class View extends Backbone.View {
  initialize(options = {}) {
    this.options = _.defaults(options, defaultOptions);
    this.i18nStrings = _.defaults({}, this.options.i18nStrings, defaultOptions.i18nStrings);
    this.koModel = new ViewModel(_.pick(this.options, 'language', 'languages', 'withInheritOption', 'enableArabic', 'enableSimplifiedChinese', 'IsAdsGlobalizationPhase1Enabled', 'IsAdsGlobalizationPhase2Enabled', 'IsAdsGlobalizationPhase2JapanEnabled', 'IsAdsGlobalizationPhase6Enabled', 'IsDomesticSimplifiedChineseEnabled', 'IsAdsGlobalizationPhase9Enabled', 'IsAdsGlobalizationPhase9VIEnabled'));
    this.koModel.language.subscribe((language) => {
      eventDispatcher.trigger('language:changed', language);
      this.trigger('language:changed', language);
    }, this);
    this.on('language:set', (lang) => this.koModel.language(lang));
  }

  render() {
    this.$el.empty().append(template({
      Description: this.i18nStrings.Description,
      SaveWarning: this.i18nStrings.SaveWarning,
      ChooseLanguage: this.i18nStrings.ChooseLanguage,
    }));
    ko.applyBindings(this.koModel, this.el);
    return this;
  }
}
